module.exports = __webpack_public_path__ + "assets/img/help1.93b2fb68.png";